import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signin-reset_password-click';
/**
 * Track reset password click event
 */
export function trackSigninResetPasswordClick(sign_in_view_string) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { sign_in_view_string },
    });
}
